const getInitial = (name: string) => (name?.[0] ?? '').toUpperCase();

/** Returns uppercase first and last initials; missing names contribute no initial. */
const getInitials = (model: { firstName?: string | null; lastName?: string | null }) =>
  `${getInitial(model.firstName ?? '')}${getInitial(model.lastName ?? '')}`;

export { getInitials };

export default null; // silence a false warning
